import { Button, Checkbox, CheckboxStates, Field, Modal, Table } from '@teamsnap/teamsnap-ui';
import { uniq } from 'lodash';
import * as React from 'react';
import { SeasonGuideContext } from './season-guide';
import './select-age-groups.scss';

const getCheckboxState = (ageGroups: any[], options: any[]) => {
  if (ageGroups.length === 0) return CheckboxStates.FALSE;

  if (ageGroups.length !== options.length) return CheckboxStates.INDETERMINATE;

  if (ageGroups.length === options.length) return CheckboxStates.TRUE;
};

const SelectAgeGroups = () => {
  const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);
  const [newAgeGroupName, setNewAgeGroupName] = React.useState<string>('');
  const { season, setSeason } = React.useContext(SeasonGuideContext);
  const [options, setOptions] = React.useState(
    uniq([...season.ageGroupsOptions, ...season.ageGroups.map((x) => x.id)])
  );

  const checkboxState = getCheckboxState(season.ageGroups, options);

  const cols = [
    {
      name: 'selected',
      label: (
        <div>
          <Checkbox
            name="select-all"
            mods="u-padBottomNone"
            inputProps={{
              checked: checkboxState,
              onClick: () => {
                setSeason({
                  ageGroups: checkboxState !== CheckboxStates.FALSE ? [] : options.map((x) => ({ id: x, genders: [] })),
                });
              },
            }}
          />
        </div>
      ),
      mods: 'u-size1of12',
    },
    {
      name: 'groupName',
      label: 'Age Group',
      mods: 'u-size11of12',
    },
  ];

  const selectedIds = season.ageGroups.map((x) => x.id);
  const rows = options.map((ele, i) => ({
    id: i,
    groupName: ele,
    selected: (
      <div>
        <Checkbox
          name={`select-${ele}`}
          mods="u-padBottomNone"
          inputProps={{
            checked: selectedIds.includes(ele),
            onClick: () => {
              setSeason({
                ageGroups: season.ageGroups.some((x) => x.id === ele)
                  ? season.ageGroups.filter((x) => x.id !== ele)
                  : [...season.ageGroups, { id: ele, genders: [] }],
              });
            },
          }}
        />
      </div>
    ),
  }));

  return (
    <div className="select-age-groups">
      <h2 className="u-spaceTopLg u-padTopLg">Select your age groups</h2>
      <div className="FieldGroup-message FieldGroup-message">
        We made your age range into age groups. Select the ones you want to keep.
        <br />
        You may add new age groups, such as "U-13/14".
      </div>
      <div className="Grid-cell u-spaceTopSm">
        <Table columns={cols} rows={rows} />
      </div>

      <div className="Grid-cell u-xs-size1of2">
        <Button
          testId="new-form-button"
          color="primary"
          icon="plus"
          iconPosition="left"
          onClick={() => setIsModalOpen(true)}
        >
          Add Age Group
        </Button>
      </div>
      <Modal heading="" show={isModalOpen} closeFn={() => setIsModalOpen(false)}>
        <Field
          data-testid="season-age-group-name"
          type="input"
          name="ageGroupName"
          label="Age Group Title"
          formFieldProps={{
            size: 'large',
            placeholder: 'U13-14',
            inputProps: {
              value: newAgeGroupName,
              onChange: (e) => setNewAgeGroupName(e.target.value),
            },
          }}
        />
        <div className="btn-group u-spaceTopMd u-textRight">
          <Button
            type="link"
            mods="u-spaceRightSm u-colorGrey"
            onClick={() => {
              setNewAgeGroupName('');
              setIsModalOpen(false);
            }}
          >
            <span>Cancel</span>
          </Button>
          <Button
            type="link"
            onClick={() => {
              setOptions([...options, newAgeGroupName]);
              setSeason({ ageGroups: [...season.ageGroups, { id: newAgeGroupName, genders: [] }] });
              setNewAgeGroupName('');
              setIsModalOpen(false);
            }}
          >
            <span>Add</span>
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default SelectAgeGroups;
